import TurboPower from "turbo_power"
// @ts-expect-error Turbo has dropped TypeScript support
import { Turbo } from "@hotwired/turbo-rails"

TurboPower.initialize(Turbo.StreamActions)
